import React from 'react';

import { HorizontalContainer } from '@/components';

type ActionBarContainerProps = {
    children: React.ReactNode;
};

export const ActionBarContainer = ({ children }: ActionBarContainerProps) => {
    return (
        <HorizontalContainer
            className="ml-auto flex-wrap items-center py-4"
            spacing="md"
        >
            {children}
        </HorizontalContainer>
    );
};
